import { render } from "./TwoFactorLayer.vue?vue&type=template&id=1454d762&scoped=true&ts=true"
import script from "./TwoFactorLayer.vue?vue&type=script&lang=ts"
export * from "./TwoFactorLayer.vue?vue&type=script&lang=ts"

import "./TwoFactorLayer.vue?vue&type=style&index=0&id=1454d762&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1454d762"]])

export default __exports__